import React from 'react';
import * as e from '../elements';

export default {
  name: 'Image-only Cover',
  description: 'Full-screen image and nothing else.',
  thumb: 'cover-image',
  tags: ['Cover'],
  jsx: (
    <e.PBlock
      height="full"
      pad="md"
      backgroundImage="https://lh3.googleusercontent.com/yWZuhf1qycDr7_2cTPbL0BXIWvNSkKgvk0AjpH5vUoXk2iRJl-oKhimWmLXYbTuiGWTF0c10oNkRvA2ZGWFD"
    />
  ),
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/CoverImage.jsx